import React from "react"

interface LocaleContextInterface {
  language?: string
  languages?: string[]
  defaultLanguage?: string
  path?: string
}

const LocaleContext = React.createContext<LocaleContextInterface>({})

export default LocaleContext
